import type { TFunction } from 'i18next';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Account } from '@feathr/blackbox';
import { StatusPillCell } from '@feathr/components';
import { packageLicenseTierToLabelMap } from '@feathr/extender/styles/license';

export interface IPackageCellProps {
  original: Account;
  t: TFunction;
}

/**
 * License package for the accounts table, rendered as a status pill. The theme is always neutral:
 * a package tier describes what an account bought, not the health of anything, so tinting it
 * would imply a judgement the data does not carry.
 */
function PackageCell({ original, t }: Readonly<IPackageCellProps>): JSX.Element {
  const activePackage = original.activePackage?.name;

  return (
    <StatusPillCell
      status={
        activePackage ? packageLicenseTierToLabelMap(t, activePackage) : t('No active license')
      }
      theme={'neutral'}
      truncate={false}
    />
  );
}

export default observer(PackageCell);
